import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SiteFooter from "@/components/SiteFooter";

export const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-lg font-display font-bold mb-3 text-foreground">{title}</h2>
    <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">{children}</div>
  </section>
);

export default function LegalLayout({ title, updated, children, testid }) {
  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid={testid}>
      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src="/brand-icon.png" alt="AutoGridSocial" className="h-8 w-8 rounded-lg" />
            <span className="font-display font-bold">AutoGridSocial</span>
          </Link>
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1.5">
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
        </div>
      </header>
      <main className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 py-12 w-full">
        <h1 className="text-3xl font-display font-bold tracking-tight mb-2">{title}</h1>
        <p className="text-xs text-muted-foreground mb-10">Last updated: {updated} · AutoGridSocial — operated by Beckett LLC</p>
        {children}
        <p className="text-xs text-muted-foreground mt-12 pt-6 border-t border-border">
          Questions about this policy? Contact us at{" "}
          <a href="mailto:beckettseb367@gmail.com" className="underline hover:text-foreground">beckettseb367@gmail.com</a>.
          These pages are provided as general templates and are not legal advice.
        </p>
      </main>
      <SiteFooter />
    </div>
  );
}
